module.exports = __webpack_public_path__ + "static/media/logoTop.20e06fda.svg";